var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogoOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 29,
    viewBox: "0 0 165 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6887_302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7352 9.15039V19.8488H42.5353V15.0811H36.3789V19.8488H35.1797V9.15039H36.3789V13.9018H42.5353V9.15039H43.7352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5564 10.3144V13.9021H64.4414V15.0821H58.5564V18.6861H65.1451V19.8498H57.3578V9.15137H65.1451V10.315H58.5564V10.3144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3106 9.15039V18.6851H85.0832V19.8488H78.1113V9.15039H79.3106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8661 19.8488H97.6669V9.15039H98.8661V19.8488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.469 16.649H121.732C121.06 18.6048 119.333 19.9781 116.935 19.9781C113.752 19.9781 111.818 17.5378 111.818 14.4993C111.818 11.4608 113.753 9.02051 116.935 9.02051C119.333 9.02051 121.06 10.3944 121.732 12.3496H120.469C119.925 11.0403 118.774 10.1999 117.03 10.1999C114.456 10.1999 113.017 12.091 113.017 14.4987C113.017 16.9064 114.456 18.7975 117.03 18.7975C118.773 18.7975 119.925 17.9571 120.469 16.6478V16.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.798 19.8488H142.47L141.175 16.7457H135.93L134.635 19.8488H133.307L137.801 9.15039H139.304L143.798 19.8488ZM140.712 15.631L138.553 10.4107L136.393 15.631H140.711H140.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.788 19.8488H156.589V9.15039H161.355C163.609 9.15039 165 10.4917 165 12.5925C165 14.6932 163.609 16.0346 161.355 16.0346H157.788V19.8482V19.8488ZM157.788 10.2978V14.9035H161.275C162.938 14.9035 163.801 14.0311 163.801 12.5925C163.801 11.1539 162.938 10.2978 161.275 10.2978H157.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1314 17.1475H9.24414V15.5246H15.6893V22.1055C16.7492 21.8378 17.3961 21.5079 17.3668 20.2814C17.2897 17.0804 17.3405 13.877 17.3405 10.6736V9.47363C18.578 9.80594 19.14 10.3443 19.0951 11.659C18.9893 14.857 19.0395 18.0634 19.0766 21.2638C19.0766 22.0058 18.899 22.4662 18.2181 22.8202C16.8927 23.506 15.6421 24.2878 14.129 25.1615L14.1314 17.1475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6762 12.1252V13.7323H9.18025V7.14843C7.99536 7.46442 7.4896 7.98161 7.52667 9.19482C7.61933 12.3179 7.55835 15.4464 7.55596 18.5695V19.831C6.42965 19.4558 5.76188 19.0625 5.80134 17.7526C5.89938 14.5141 5.85455 11.2678 5.81987 8.02692C5.81987 7.28497 5.99743 6.82458 6.68373 6.46811C8.00911 5.78235 9.25976 4.99206 10.7442 4.12988V12.1227L15.6762 12.1252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.782 10.47H14.1439V4.15918C15.0425 4.66549 15.7951 5.08057 16.5292 5.51197C18.1828 6.47082 19.8185 7.46169 21.4876 8.39154C22.049 8.65376 22.3838 9.24829 22.3198 9.87C22.2881 12.9556 22.2534 16.0303 22.3329 19.1268C22.3646 20.3292 21.8613 20.8838 20.6501 21.2052V19.5981C20.6501 16.5904 20.6262 13.5797 20.6662 10.5715C20.7344 9.9558 20.3936 9.36852 19.8286 9.12805C18.517 8.42659 17.2472 7.64416 15.7736 6.78983L15.7814 10.47H15.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24032 8.06468V15.8485C4.24032 17.1155 3.8876 18.6235 4.44179 19.5848C4.99597 20.5467 6.47739 20.9672 7.55826 21.6149C8.01141 21.8826 8.47771 22.1321 9.12217 22.4934V18.8719H10.7602V25.0322C10.435 24.9108 10.1164 24.7712 9.80608 24.6141C7.68559 23.39 5.58961 22.1363 3.46135 20.931C2.86711 20.6488 2.5132 20.0186 2.57896 19.3588C2.61603 16.3137 2.65309 13.2625 2.56581 10.2198C2.51559 8.97701 3.0351 8.40122 4.24092 8.06348L4.24032 8.06468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21.7491V7.24789L12.4246 0L24.8492 7.25091V21.7497L12.4246 29.0006L0 21.7491ZM24.0751 7.70042L12.4139 0.902663L0.752663 7.70042V21.2966L12.4139 28.0943L24.0751 21.2966V7.70042Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6887_302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogoOnboarding);
export default __webpack_public_path__ + "static/media/white_logo_onboarding.e6ea25bcf56c3daa4926bc949aad3d1c.svg";
export { ForwardRef as ReactComponent };